import React, {useState, useEffect} from 'react';
import styled from 'styled-components';

import StorageService from '../../services/StorageService';

import {BREAKPOINT_XS} from './../../config';

const Wrapper = styled.section`
  min-height: ${props => props.minHeight ? props.minHeight : "auto"};
  display: flex;
  flex-direction: row;
  @media (max-width: ${BREAKPOINT_XS}px){
    flex-direction: column;
  }

  ${props => props.variant === "blue" ? `
    background-color: #2086F2;
    color: #ffffff;
  ` : ""}

  ${props => props.variant === "white" ? `
    background-color: #ffffff;
    color: #000000;
  ` : ""}

`;

const SlotSide = styled.div`
  flex-basis: calc(50% - 100px);
  @media (max-width: ${BREAKPOINT_XS}px){
    flex-basis: 100vw;
  }
  flex-grow: 0;
  flex-shrink: 0;
  background-image: url('${props => props.src}');
  background-position: center;
  background-size: cover;
  margin: 50px;
`;
const SlotCx = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Section = ({
  variant="default", 
  imageSx = null,
  imageDx = null,
  minHeight = null,
  children
}) => {
  const [srcImageSx, setSrcImageSx] = useState(null);
  const [srcImageDx, setSrcImageDx] = useState(null);
  
  useEffect(() => {
    if(imageSx){
      StorageService.getUrl(imageSx).then((response) => {
        setSrcImageSx(response);
      });
    }
  }, [imageSx]);
  
  useEffect(() => {
    if(imageDx){
      StorageService.getUrl(imageDx).then((response) => {
        setSrcImageDx(response);
      });
    }
  }, [imageDx]);

  return (
    <Wrapper variant={variant} minHeight={minHeight}>
      {window.screen.width <= BREAKPOINT_XS ? 
        <SlotCx>
          {children}
        </SlotCx>
      : null}
      {srcImageSx ? 
        <SlotSide src={srcImageSx} />
      : null }
      {window.screen.width > BREAKPOINT_XS ? 
        <SlotCx>
        {children}
        </SlotCx>
      : null}
      {srcImageDx ? 
        <SlotSide src={srcImageDx} />
      : null }
    </Wrapper>
  )
}

export default Section;